import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=3c906ad8&scoped=true&"
import script from "./pageWrapper.ts?vue&type=script&lang=ts&"
export * from "./pageWrapper.ts?vue&type=script&lang=ts&"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=3c906ad8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c906ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
